var map = {
	"./aspdotnet.svg": 3629,
	"./aws.png": 8985,
	"./aws.svg": 6371,
	"./c-sharp.png": 5726,
	"./c-sharp.svg": 260,
	"./database-sql.svg": 6368,
	"./docker.svg": 4936,
	"./javascript.svg": 8109,
	"./microsoft-azure.svg": 1634,
	"./nodejs.svg": 4333,
	"./react.svg": 785,
	"./sql-database-generic.svg": 9606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2086;